import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { TButtonTheme } from '@cian/ui-kit/button/types';

interface ICallbackButtonProps {
  onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
  loading: boolean;
  text: string;
  buttonTheme: TButtonTheme;
  beforeIcon?: React.JSX.Element;
}

export const CallbackButton: React.FC<ICallbackButtonProps> = ({ onClick, text, loading, buttonTheme, beforeIcon }) => {
  return (
    <div data-testid="CallMeBackButton">
      <Button
        onClick={onClick}
        size="M"
        theme={buttonTheme}
        beforeIcon={beforeIcon}
        type="button"
        fullWidth
        loading={loading}
      >
        {text}
      </Button>
    </div>
  );
};
